export const PRODUCT_CHANGE_STATUS = {
    UNAVAILABLE: 'UNAVAILABLE',
    PRICE_CHANGE: 'PRICE_CHANGE'
};
